export default __webpack_public_path__ + "static/media/pizza8.34337488.jpg";